export default __webpack_public_path__ + "static/media/ph_note-light.e6738367.svg";